import { render, staticRenderFns } from "./xhsParticipateRecord.vue?vue&type=template&id=29c23209&scoped=true"
import script from "./xhsParticipateRecord.vue?vue&type=script&lang=js"
export * from "./xhsParticipateRecord.vue?vue&type=script&lang=js"
import style0 from "./xhsParticipateRecord.vue?vue&type=style&index=0&id=29c23209&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29c23209",
  null
  
)

export default component.exports